import React from 'react';

import Icon from '../../shared/icon/Icon';

interface IOwnProps {
    initialValue?: string,
    modifierClass?: string;
    name: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    invalid?: boolean;
    notice?: React.ReactNode;
    showNotice?: boolean;
    icon?: string;
    hasContainer?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    validator?: (s: string) => boolean;
}

type Props = IOwnProps;

interface IOwnState {
    value: string | undefined;
    isDirty: boolean;
    invalid?: boolean;
}

class FormSearch extends React.Component<Props, IOwnState> {
    private input = React.createRef<HTMLInputElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            value: props.initialValue,
            isDirty: false,
            invalid: props.invalid
        };
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({ value: this.props.initialValue, invalid: !this.validate(this.props.initialValue) });
        }
    }

    public focus = () => {
        this.input.current!.focus();
    }

    public render() {
        return <div className="form__section__inner">
            <div className={'form__field form__field--search'.cAppend(this.props.modifierClass)
                .cAppend(this.props.required, 'is-required')
                .cAppend(this.props.disabled, 'is-disabled')
                .cAppend(this.props.invalid || (this.state.isDirty && this.state.invalid), 'is-invalid')
            }>
                {this.props.hasContainer ? <div className="form__container">{this.renderField()}</div> : this.renderField()}
                {((this.props.invalid || (this.state.isDirty && this.state.invalid)) || this.props.showNotice) && this.props.notice && <span className="form__notice" dangerouslySetInnerHTML={{ __html: this.props.notice.toString() }} />}
                {this.props.children}
            </div>
        </div>;
    }

    public value = () => this.state.value;

    public isChanged = () => this.props.initialValue !== this.state.value;

    public isValid = (blur: boolean = true) => {
        if (blur) {
            this.handleBlur(); // if checking isValid, assume form submission has been attempted and that field state is considered dirty
        }

        return this.validate(this.state.value);
    };

    private renderField() {
        return <React.Fragment>
            {this.props.label &&
                <label htmlFor={this.props.name} className="form__label">
                    <span className="form__label__text">{this.props.label}{this.props.required && <React.Fragment>&nbsp;&nbsp;<strong>&#10033;</strong></React.Fragment>}</span>
                </label>
            }
            <div className="form__field--search__input">
                <input type="text" id={this.props.name} name={this.props.name} value={this.state.value} className="form__item" placeholder={this.props.placeholder} disabled={this.props.disabled} onChange={this.handleChange} ref={this.input} onBlur={this.handleBlur} />
                <button type="submit" className="form__field--search__input-button">
                    <Icon name="search" />
                </button>
            </div>
        </React.Fragment>;
    }

    private validate = (value: string | null | undefined) => {
        if (!value) {
            return !this.props.required;
        }

        if (this.props.validator) {
            return this.props.validator(value);
        }

        return true;
    }

    private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.persist();

        this.setState({
            value: e.target.value,
            invalid: !this.validate(e.target.value)
        }, () => this.props.onChange ? this.props.onChange(e) : {});
    }

    private handleBlur = () => {
        this.setState({ isDirty: true });
    }
}

export default FormSearch;